import api from '../api'

// initial state
const state = {
  lessons: {
    list: [],
    pageCount: 0,
    totalCount: 0,
    pageIndex: 1,
    pageSize: 12,
    filter: {
      language: '',
      categoryId: '',
      level: ''
    }
  },

  filters: [],

  lesson: {
    categoryName: null,
    cover: null,
    id: null,
    language: null,
    level: null,
    localName: '',
    name: '',
    practices: null,
    modules: []
  }
}

// getters
const getters = {
  lessonFilters: state => state.filters,
  lessonList: state => state.lessons,
  lesson: state => state.lesson
}

// actions
const actions = {
  getLessonFilters: ({ commit }) => {
    api.get('/Lesson/Fillters')
      .then((response) => {
        commit('updateLessonFilters', response.data)
      })
  },

  getLessonList: ({ state, commit }, params) => {
    params = params || {}

    if (params.language && params.language !== state.lessons.filter.language) {
      commit('resetLessonListFilter')
    }

    let filter = {
      language: params.language || state.lessons.filter.language,
      categoryId: params.categoryId || state.lessons.filter.categoryId,
      level: params.level || state.lessons.filter.level
    }

    if (params.language === '') {
      filter.language = ''
    }

    if (params.categoryId === '') {
      filter.categoryId = ''
    }

    if (params.level === '') {
      filter.level = ''
    }

    commit('updateLessonListFilter', filter)

    let data = {
      pageIndex: params.pageIndex || state.lessons.pageIndex,
      pageSize: params.pageSize || state.lessons.pageSize,
      language: state.lessons.filter.language,
      categoryId: state.lessons.filter.categoryId,
      level: state.lessons.filter.level
    }

    api.get('/Lesson', { params: data })
      .then((response) => {
        commit('updateLessonList', response.data)
      })
  },

  getLesson: async ({ commit, dispatch }, id) => {
    commit('resetLesson')

    const { data } = await api.get('/Lesson/' + id)

    commit('updateLesson', data.data)

    await dispatch('getPractice', id)

    if (data.data.modules) {
      data.data.modules.forEach((el) => {
        dispatch('getLessonMudule', el.id)
      })
    }
  },

  getPractice: ({ commit }, id) => {
    api.get('/Lesson/' + id + '/Practices')
      .then((response) => {
        commit('updatePractice', response.data)
      })
  },

  getLessonMudule: ({ commit }, moduleId) => {
    api.get('/LessonModule/' + moduleId)
      .then((response) => {
        commit('updateLessonMudule', response.data)
      })
  },

  postLessonRecord: (id, type) => {
    api.post('/Lesson/' + id + '/Record/' + type)
  },

  postLessonPracticeRecord: (id, score) => {
    api.post('/Lesson/' + id + '/Record/Practices', { data: { score: score } })
  }
}

// mutations
const mutations = {
  updateLessonFilters: (state, payload) => {
    state.filters = payload.data
  },

  updateLessonList: (state, payload) => {
    state.lessons.list = payload.data
    state.lessons.pageCount = payload.pageCount
    state.lessons.pageSize = payload.pageSize
    state.lessons.pageIndex = payload.pageIndex || 1
    state.lessons.totalCount = payload.totalCount
  },

  updateLesson: (state, payload) => {
    Object.keys(payload).forEach(function (key) {
      if (key !== 'modules') {
        state.lesson[key] = payload[key]
      }
    })
  },

  updatePractice: (state, payload) => {
    state.lesson.practices = payload.data
  },

  updateLessonMudule: (state, payload) => {
    state.lesson.modules.push(payload.data)
  },

  resetLesson: (state) => {
    state.lesson.data = null
    state.lesson.practice = null
    state.lesson.modules = []
  },

  updateLessonListFilter: (state, payload) => {
    state.lessons.filter.language = payload.language
    state.lessons.filter.categoryId = payload.categoryId
    state.lessons.filter.level = payload.level
  },

  resetLessonListFilter: (state) => {
    state.lessons.filter.language = ''
    state.lessons.filter.categoryId = ''
    state.lessons.filter.level = ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/lesson.js